import moment from 'moment';

/** Example: January 11, 2021 */
export function formatDate(dateString) {
    if (!dateString) {
        return '';
    }
    try {
        return moment(dateString).format('LL');
        //const dt = new Date(dateString);
        //const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        //return dt.getDate() + ' ' + monthNames[dt.getMonth()] + ' ' + dt.getFullYear();
    } catch (e) {
        return '';
    }
}

export function joinPath(...parts) {
    if (!parts) return '';
    let result = '';
    for (let i = 0; i < parts.length; i++) {
        result +=
            parts[i].startsWith('/') && i > 0 ? parts[i].substr(1) : parts[i];

        if (i !== parts.length - 1 && !result.endsWith('/')) result += '/';
    }

    return result;
}

export function resourcePath(path) {
    if (!path) return path;
    if (path.startsWith('http://') || path.startsWith('https://')) return path;
    if (path.startsWith('/static')) {
        return joinPath("https://resources.awarego.com/", path.replace('/static', ''));
    }
    return path;
}

export const primaryColor = (props) =>
    props.color || props.theme.primary || '#20A26B';

export function calculateColor(number) {
    if (number) {
        if (number <= 24) return '#EB5757';
        if (number <= 49) return '#FF8440';
        if (number <= 74) return '#F2C94C';
        if (number <= 89) return '#8CBD00';
        return '#20A26B';
    } else {
        return '#EB5757';
    }
}

export function calculateScoreTitle(percentage) {
    if (percentage <= 24) return 'Very risky';
    if (percentage <= 49) return 'Risky';
    if (percentage <= 74) return 'Fair';
    if (percentage <= 89) return 'Very good';
    return 'Excellent';
}

export function defaultZero(value) {
    return value || 0;
}

export function calculateSeverityColor(variant) {
    //if (variant === 'error') return 'danger';
    return variant;
}
